import React from "react";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import SvgIcon from "@mui/material/SvgIcon";

import creditCardIcons from "../../../common/creditCardIcons";
import {COLORS} from "../../../../colorThemes";

const _getSvgCardIcon = (iconName) => <SvgIcon fontSize="large" viewBox={"0 0 78 50"}>{creditCardIcons[iconName]}</SvgIcon>;

export default function getCreditCardType(testCard) {
  const cardNumber = testCard.replaceAll(/ /g, "");
  let amex = new RegExp('^3[47][0-9]{13}$');
  let visa = new RegExp('^4[0-9]{12}(?:[0-9]{3})?$');
  let cup1 = new RegExp('^62[0-9]{14}[0-9]*$');
  let cup2 = new RegExp('^81[0-9]{14}[0-9]*$');

  let mastercard = new RegExp('^5[1-5][0-9]{14}$');
  let mastercard2 = new RegExp('^2[2-7][0-9]{14}$');

  let disco1 = new RegExp('^6011[0-9]{12}[0-9]*$');
  let disco2 = new RegExp('^62[24568][0-9]{13}[0-9]*$');
  let disco3 = new RegExp('^6[45][0-9]{14}[0-9]*$');

  let diners = new RegExp('^3[0689][0-9]{12}[0-9]*$');
  let jcb =  new RegExp('^35[0-9]{14}[0-9]*$');


  if (visa.test(cardNumber)) {
    return {text: "Visa", icon: _getSvgCardIcon("visa")};
  }
  if (amex.test(cardNumber)) {
    return {text: "AmEx", icon: _getSvgCardIcon("amex")};
  }
  if (mastercard.test(cardNumber) || mastercard2.test(cardNumber)) {
    return {text: "Mastercard", icon: _getSvgCardIcon("mastercard")};
  }
  if (disco1.test(cardNumber) || disco2.test(cardNumber) || disco3.test(cardNumber)) {
    return {text: "Discover", icon: _getSvgCardIcon("discover")};
  }
  if (diners.test(cardNumber)) {
    return {text: "Diners", icon: <SvgIcon fontSize="large" viewBox={"0 0 100 100"}>{creditCardIcons["diners"]}</SvgIcon>};
  }
  if (jcb.test(cardNumber)) {
    return {text: "JCB", icon: _getSvgCardIcon("jcb")};
  }
  if (cup1.test(cardNumber) || cup2.test(cardNumber)) {
    return {text: "Union Pay", icon: _getSvgCardIcon("unionPay")};
  }
  return {text: "", icon: <CreditCardIcon style={{'color': COLORS.gray2}}/>};
}
